export const SORT_VALUES = Object.freeze({
  greaterThan: 1,
  lessThan: -1,
  equal: 0,
})
